import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { UserRole } from "../../../@types/userRole";
import api from "../../../utils/api";
import axiosInstance from "../../../utils/axiosConfig";

export const findSingleUserRoleByCode = createAsyncThunk(
  "massiveDocumentCreate/findSingleUserRoleByCode",
  async (code : string, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get(`${api.baseURL}userrole`, {
        params: {
            where: {
                code: code,
                enabled: true,
            },
        },
    });

      return data as UserRole[];
    } catch (error:any) {
      const {message} = error
      rejectWithValue(message);
      throw message;
    }
  }
);
